import { ReactElement } from 'react';

export const BottomIcon = ({ children }: { children: ReactElement }) => <span id='avatar-bottom-icon'>{children}</span>;
